export const tags = {
    "TY": "Type of reference",
    "A1": "Primary Authors",
    "A2": "Secondary Authors",
    "A3": "Tertiary Authors",
    "A4": "Subsidiary Authors",
    "AB": "Abstract",
    "AD": "Author Address",
    "AN": "Accession Number",
    "AU": "Author",
    "AV": "Location in Archives",
    "BT": "Should be used only ",
    "C1": "Custom 1",
    "C2": "Custom 2",
    "C3": "Custom 3",
    "C4": "Custom 4",
    "C5": "Custom 5",
    "C6": "Custom 6",
    "C7": "Custom 7",
    "C8": "Custom 8",
    "CA": "Caption",
    "CN": "Call Number",
    "CP": "?",
    "CT": "Title of unpublished reference",
    "CY": "Place Published",
    "DA": "Date",
    "DB": "Name of Database",
    "DO": "DOI",
    "DP": "Database Provider",
    "ED": "Editor",
    "EP": "End Page",
    "ET": "Edition",
    "ID": "Reference ID",
    "IS": "Issue number",
    "J1": "Periodical name: user abbreviation 1",
    "J2": "Alternate Title",
    "JA": "Periodical name: standard abbreviation",
    "JF": "Journal/Periodical name: full format",
    "JO": "Journal/Periodical name: full format",
    "KW": "Keywords",
    "L1": "Link to PDF",
    "L2": "Link to Full-text",
    "L3": "Related Records",
    "L4": "Image(s)",
    "LA": "Language",
    "LB": "Label",
    "LK": "Website Link",
    "M1": "Number",
    "M2": "Miscellaneous 2",
    "M3": "Type of Work",
    "N1": "Notes",
    "N2": "Abstract",
    "NV": "Number of Volumes",
    "OP": "Original Publication",
    "PB": "Publisher",
    "PP": "Publishing Place",
    "PY": "Publication year",
    "RI": "Reviewed Item",
    "RN": "Research Notes",
    "RP": "Reprint Edition",
    "SE": "Section",
    "SN": "ISBN/ISSN",
    "SP": "Start Page",
    "ST": "Short Title",
    "T1": "Primary Title",
    "T2": "Secondary Title",
    "T3": "Tertiary Title",
    "TA": "Translated Author",
    "TI": "Title",
    "TT": "Translated Title",
    "U1": "User definable 1",
    "U2": "User definable 2",
    "U3": "User definable 3",
    "U4": "User definable 4",
    "U5": "User definable 5",
    "UR": "URL",
    "VL": "Volume number",
    "VO": "Published Standard number",
    "Y1": "Primary Date",
    "Y2": "Access Date",
    "ER": "End of Reference",
    "PMID": "PMID",
    "XX": "Readcube dummy tag",
};
export const aliases = {
    'A1': 'AU',
    'DA': 'PY',
    'T1': 'TI',
    'JF': 'T2',
};
